import { Component } from 'react';
import ButtonGroup from 'components/ButtonGroup';
import QuestionList from './QuestionList';
import ResponsesOfQuestion from './ResponsesOfQuestion';
import RelatedResponsesList from './RelatedResponsesList';
import { RelatedListWrapper } from './styles';
import { IThisUser, IUsers } from 'store/store';
import {
  IMultipleChoiceQuestionView,
  IQuestionsView,
  ISurveyItem,
  ISurveyResponseView,
  ISurveyViewServer,
  ISurveyViewWithData,
} from 'store/survey/surveyTypes';
import { ITags } from 'store/providers/providerTypes';
import i18n from '../../../i18n';

interface IComponentStates {
  viewType: 'separatedBySendTime' | 'separatedByQuestion';
  selectedQuestion: {
    surveyId: number;
    questionId: number;
    gridPartValue?: string;
  } | null;
}

interface IComponentProps {
  tags: ITags['data'];
  title: string;
  users: IUsers['map'];
  surveys: ISurveyViewServer[];
  thisUser: IThisUser;
  responses: Array<ISurveyResponseView>;
  selectedTags: number[];
  selectedChoices: Array<string | number>;
  local: string;
  survey?: ISurveyViewWithData;
  providerId: number | undefined;
  surveyItem?: ISurveyItem;
  isInDashboardView: boolean;
}

class RelatedResponsesContainer extends Component<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {
    viewType: 'separatedBySendTime',
    selectedQuestion: null,
  };

  ButtonGroupItems = {
    separatedBySendTime: i18n.t('separatedBySendTime', { ns: 'survey' }),
    separatedByQuestion: i18n.t('separatedByQuestion', { ns: 'survey' }),
  };

  handleChangeViewType = (itemKey: string) => {
    this.setState({
      viewType: itemKey as 'separatedBySendTime' | 'separatedByQuestion',
    });
  };

  handleCloseQuestion = () => {
    this.setState({ selectedQuestion: null });
  };

  handleClickOnQuestion =
    (surveyId: number, questionId: number, gridPartValue?: string) => () => {
      let newPartValue;
      const { selectedQuestion } = this.state;
      if (
        selectedQuestion &&
        gridPartValue === selectedQuestion.gridPartValue
      ) {
        // to unselect selected grid part
        newPartValue = undefined;
      } else {
        newPartValue = gridPartValue;
      }
      this.setState({
        selectedQuestion: { questionId, surveyId, gridPartValue: newPartValue },
      });
    };

  render() {
    const {
      tags,
      users,
      surveys,
      responses,
      selectedTags,
      selectedChoices,
      title,
      local,
      survey,
      surveyItem,
      providerId,
      isInDashboardView,
    } = this.props;

    const { viewType, selectedQuestion } = this.state;

    let question: IQuestionsView | undefined;
    let surveyOfQuestion: ISurveyViewServer | undefined;
    if (selectedQuestion) {
      surveyOfQuestion = surveys.find(
        (survey) => survey.id === selectedQuestion.surveyId
      );
      if (surveyOfQuestion) {
        question = surveyOfQuestion.surveyQuestionList.find(
          (q) => q.id === selectedQuestion.questionId
        );
      }
    }

    return (
      <div style={{ marginTop: '1em' }}>
        <ButtonGroup
          items={this.ButtonGroupItems}
          selected={viewType}
          onSelect={this.handleChangeViewType}
        />
        {viewType === 'separatedBySendTime' ? (
          surveys && (
            <RelatedResponsesList
              title={title}
              tags={tags}
              users={users}
              survey={survey}
              surveys={surveys}
              responses={responses}
              selectedTags={selectedTags}
              selectedChoices={selectedChoices}
              surveyItem={surveyItem}
              local={local}
              providerId={providerId}
              isInDashboardView={isInDashboardView}
            />
          )
        ) : (
          <RelatedListWrapper>
            <QuestionList
              surveys={surveys}
              survey={survey}
              selectedTags={selectedTags}
              gridPartValue={
                selectedQuestion ? selectedQuestion.gridPartValue : undefined
              }
              onClickOnQuestion={this.handleClickOnQuestion}
              selectedQuestionId={
                selectedQuestion && selectedQuestion.questionId
              }
            />
            {surveys && question && selectedQuestion && surveyOfQuestion && (
              <ResponsesOfQuestion
                tags={tags}
                users={users}
                question={question}
                responses={responses!}
                selectedTags={selectedTags}
                gridPartValue={selectedQuestion.gridPartValue}
                onCloseQuestion={this.handleCloseQuestion}
                selectedChoices={selectedChoices}
                distinctiveQuestions={
                  surveyOfQuestion.surveyQuestionList.filter(
                    (q) =>
                      q.type === 'multipleChoice' && !q.deleted && q.distinctive
                  ) as IMultipleChoiceQuestionView[]
                }
                providerId={this.props.providerId}
              />
            )}
          </RelatedListWrapper>
        )}
      </div>
    );
  }
}

export default RelatedResponsesContainer;
